import SecurePayments from "../../components/SecurePayments";
import AudioSamplePlayer from "../../components/AudioSamplePlayer";
import { courses } from "../../data/online-traffic-school";
import heroBanner from "../../assets/images/4-hour-bdi.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMoneyBill } from "@fortawesome/free-solid-svg-icons";
import ShellCard from "../../components/ShellCard";
import "./FourHourBDI.css";

const FourHourBasicDriver = () => {
  const course = courses?.find((c) => c.id === 1);

  return (
    <>
      <section className="hero-slider-section">
        <div
          className="hero-banner"
          style={{
            backgroundImage: `url(${heroBanner})`,
          }}
        >
          <div className="banner-text-container">
            <div className="banner-heading">
              <h1 className="banner-title">
                4 Hour Basic Driver Improvement Course
              </h1>
              <p className="banner-subheading">Florida DMV Approved</p>
            </div>
          </div>
        </div>
      </section>
      <main className="bdi-page" style={{ marginBottom: "58px" }}>
        <div className="container mt-5">
          <div className="row">
            <div className="col-12">
              <ShellCard>
                <h3 className="mb-4" style={{ color: "var(--metro-yellow)" }}>
                  Course Details
                </h3>

                <p className="lead py-3">
                  The 4 Hour Basic Driver Improvement (B.D.I.) course may be
                  completed{" "}
                  <a
                    href="/online-traffic-school"
                    className="text-warning fw-bold text-decoration-none"
                  >
                    Online
                  </a>
                  , or in the{" "}
                  <a
                    href="/classroom-traffic-school"
                    className="text-warning fw-bold text-decoration-none"
                  >
                    classroom
                  </a>
                  .
                </p>

                <div className="row mb-5">
                  <p className="mb-3 ps-3 border-start border-warning border-3">
                    The 4 hour B.D.I. is required by the Department of Highway
                    safety and motor vehicles for anyone who receives a moving
                    violation and elects the option to attend traffic school in
                    order to avoids points being assessed on their driving
                    record.
                  </p>
                  <p className="mb-0 ps-3 border-start border-warning border-3">
                    The 4 hour course is the most common and most widely taken
                    course. This course may be taken as an election to avoid
                    points, as a judgment (Judge Ordered), as a TCAC (Traffic
                    Collision Avoidance Course), and as defensive driving course
                    for an insurance discount. The 4 hour course may only be
                    taken once every twelve months. If you have already taken a
                    4 hour class within the past twelve months then you may be
                    eligible to take an 8 hour course.
                  </p>
                </div>

                <div className="row mb-3 align-items-stretch">
                  <div className="col-12 col-lg-4 d-flex px-0">
                    <div className="text-center w-100 h-100 d-flex flex-column justify-content-between">
                      <div className="px-3">
                        <div className="mb-3">
                          <FontAwesomeIcon
                            icon={faMoneyBill}
                            className="text-warning"
                            size="2x"
                          />
                        </div>
                        <div
                          className="fw-bold text-uppercase mb-3"
                          style={{
                            fontSize: "1rem",
                            color: "#fff",
                          }}
                        >
                          <div>4-Hour</div>
                          <div>BASIC</div>
                          <div>DRIVER IMPROVEMENT</div>
                        </div>
                        <div className="d-flex justify-content-center mb-3">
                          <span
                            className="fw-bold px-4 py-2 rounded-pill"
                            style={{
                              fontSize: "28px",
                              color: "var(--metro-yellow)",
                            }}
                          >
                            {course?.price || "$29.50"}
                          </span>
                        </div>
                        <p className="mb-4" style={{ fontSize: "0.95rem" }}>
                          The 4-hour Florida Online Traffic School is the most
                          common course to avoid points on your driver's
                          License.
                        </p>
                      </div>
                      <div className="d-grid gap-2 mt-2">
                        <a
                          className="btn btn-sm fw-bold text-dark metro-btn-primary"
                          href="https://classroom.metrotrafficschool.com/create-account/Ng=="
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ padding: "8px 15px" }}
                        >
                          <i className="fas fa-chalkboard-teacher me-2"></i>
                          Register for Classroom Course
                        </a>
                        <a
                          className="btn btn-sm fw-bold text-dark metro-btn-secondary"
                          href={
                            course?.registerUrl ||
                            "https://courses.metrotrafficschool.com/onlinecourses/registration/create_account?awc_id=Mzgy"
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ padding: "8px 15px" }}
                        >
                          <i className="fas fa-laptop me-2"></i>
                          Register for Online Course
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-lg-8 mt-4 mt-lg-0 d-flex">
                    <div className="w-100 h-100 d-flex align-items-center justify-content-center m-0 p-0">
                      <AudioSamplePlayer />
                    </div>
                  </div>
                </div>
              </ShellCard>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default FourHourBasicDriver;
